import React from 'react';
import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import IntegrationForm from './IntegrationForm';
import DataTable from '../../../modules/dataTable/DataTable/DataTable';
import { SeedIntegrationsAutoTreatContext } from '../contexts/SeedsIntegrationsAutoTreatContext';
import { integrationColumns } from '../constants/columns';
import { Machine } from '../../../modules/machinesAdminManagement/model';

interface IntegrationsListProps {
  activeMachine: Machine;
  seed: any;
}

const IntegrationsList: React.FC<IntegrationsListProps> = (props) => {
  const { seed, activeMachine } = props;

  const { seedIntegrations, seedIntegrationsLoading, seedIntegrationsSubmitting } = React.useContext(
    SeedIntegrationsAutoTreatContext,
  );
  const [showIntegrationEditForm, setShowIntegrationForm] = React.useState(false);
  const [selectedIntegration, setSelectedIntegration] = React.useState({});

  const handleAddIntegration = () => {
    setShowIntegrationForm(true);
    setSelectedIntegration({});
  };

  const handleEditIntegration = (integration) => {
    if (sessionStorage.getItem('manageIntegrationRecords') === 'true' && activeMachine.manage_integration_records) {
      setShowIntegrationForm(true);
      setSelectedIntegration(integration);
    }
  };

  return showIntegrationEditForm ? (
    <IntegrationForm
      activeMachine={activeMachine}
      seedVarietyId={seed.seed_variety_id}
      seedIntegration={selectedIntegration}
      setShowIntegrationForm={setShowIntegrationForm}
      machineSerial={activeMachine.value}
      partnerChoices={activeMachine?.api_partners?.map((partner) => ({
        label: partner.api_partner_name,
        value: partner.global_api_partner_id,
      }))}
    />
  ) : (
    <Box>
      <Grid justifyContent="space-between" container spacing={3}>
        <Grid item xs={12} md={12}>
          <Card>
            <CardContent>
              <Grid container justifyContent="space-between">
                <Grid item>
                  <Typography variant="h2" component="h2">
                    Seed Integrations
                  </Typography>
                </Grid>
                {sessionStorage.getItem('manageIntegrationRecords') === 'true' &&
                  activeMachine.manage_integration_records && (
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddIntegration}
                        disabled={activeMachine?.online_status === 'offline'}
                      >
                        Add Integration
                      </Button>
                    </Grid>
                  )}
              </Grid>
              <br />
              <DataTable
                noHeader
                columns={integrationColumns}
                data={seedIntegrations}
                defaultSortField="SeedID"
                defaultSortAsc={false}
                striped
                onRowClicked={(row) => {
                  handleEditIntegration(row);
                }}
                highlightOnHover
                pointerOnHover
                progressPending={seedIntegrationsLoading || seedIntegrationsSubmitting}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 25, 50]}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default IntegrationsList;
